import React from 'react';
import SearchEvaluator from './SearchEvaluator';
import ColumnFilterEvaluator from './ColumnFilterEvaluator';
import SortEvaluator from './SortEvalutor';

/**
 * Evaluator chain to handle table searching, sorting and pagination. This
 * approach is used in favor of storing data on context object in order to
 * reduce redraws.
 *
 * @param data Table rows in the table
 * @param children
 * @returns {*}
 */
const EvaluatorChain = ({ data, children }) => {
  return (
    <SearchEvaluator data={data}>
      {dataMatchingSearch => (
        <ColumnFilterEvaluator data={dataMatchingSearch}>
          {dataMatchingColumnFilter => (
            <SortEvaluator data={dataMatchingColumnFilter}>
              {sortedData => children(sortedData)}
            </SortEvaluator>
          )}
        </ColumnFilterEvaluator>
      )}
    </SearchEvaluator>
  );
};

export default EvaluatorChain;
